import Loading from './Loading';

export default function ConnectingView() {
   return <Loading message="Connecting" />;
}
